import { useFeatureFlag } from '@newfront-insurance/admin-ui';

import { useCanViewNovaAnalytics } from './use-can-view-nova-analytics';
import { NOVA_SCHEDULES_FEATURE_FLAG } from '../../../lib/nova-schedule-proposal';
import { DISABLED_SETTINGS_ADMINISTRATION } from '../components/skill-administration/types';
import { useChatOverlayContext, type ChatSettingsSection } from '../contexts/chat-overlay-context';

export function useActiveSettingsSection(section?: ChatSettingsSection): ChatSettingsSection {
  const { settingsSection: currentSection, settingsAdministration = DISABLED_SETTINGS_ADMINISTRATION } =
    useChatOverlayContext();
  const settingsSection = section ?? currentSection;
  const isNovaSkillsEnabled = useFeatureFlag('nova-skills', false);
  const areNovaSchedulesEnabled = useFeatureFlag(NOVA_SCHEDULES_FEATURE_FLAG, false);
  const canViewAnalytics = useCanViewNovaAnalytics();
  const administrationUnresolved =
    settingsAdministration.status === 'loading' || settingsAdministration.status === 'error';

  if (settingsSection === 'teams' && (settingsAdministration.showTeams || administrationUnresolved)) return 'teams';
  if (settingsSection === 'admins' && (settingsAdministration.showAdmins || administrationUnresolved)) return 'admins';
  if (settingsSection === 'analytics' && canViewAnalytics) return 'analytics';
  if (settingsSection === 'skills' && isNovaSkillsEnabled) return 'skills';
  if (settingsSection === 'scheduled' && areNovaSchedulesEnabled) return 'scheduled';
  return 'general';
}
